import { startTransition, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import colors from '@rewardopl/styles/colors';

import Button from '@rewardopl/react-ui/button';

import { ButtonWrapper, ContentWrapper, PageWrapper, Title } from './index.styles';

import ScrollableSlides from './scrollable_slides';
import Slide from './slide';

import { scrollToChild } from '../../../utils/carousel';

import { configLoginLoadable } from '../../../store';

import onboarding1Avif from '../../../static/onboarding/onboarding-1.avif';
import onboarding1Jpg from '../../../static/onboarding/onboarding-1.jpg';
import onboarding1Webp from '../../../static/onboarding/onboarding-1.webp';
import onboarding2Avif from '../../../static/onboarding/onboarding-2.avif';
import onboarding2Jpg from '../../../static/onboarding/onboarding-2.jpg';
import onboarding2Webp from '../../../static/onboarding/onboarding-2.webp';

const slides = [
  {
    id: 1,
    fetchPriority: 'high',
    image: onboarding1Jpg,
    imageWebp: onboarding1Webp,
    imageAvif: onboarding1Avif,
    text: 'Sign up and get your first sweet reward!',
    backgroundColor: colors['primary-light'],
  },
  {
    id: 2,
    image: onboarding2Jpg,
    imageWebp: onboarding2Webp,
    imageAvif: onboarding2Avif,
    text: 'Collect sweets and exchange them for discounts or gifts!',
    backgroundColor: colors['secondary-light'],
  },
] as const;

export default function OnboardingPage() {
  const navigate = useNavigate();
  const scrollContainer = useRef<HTMLDivElement>(null);
  const [currentChildIndex, onChildChange] = useState(0);
  useAtomValue(configLoginLoadable);

  function navigateToLogin() {
    startTransition(() => {
      navigate('/login');
    });
  }

  function scrollToNext() {
    if (!scrollContainer.current) {
      return;
    }

    scrollToChild(currentChildIndex + 1, scrollContainer.current);
  }

  const currentSlide = slides[currentChildIndex];

  if (!currentSlide) {
    throw new Error('Invalid currentChildIndex');
  }

  return (
    <>
      <meta name="theme-color" content={currentSlide.backgroundColor} />
      <PageWrapper backgroundColor={currentSlide.backgroundColor}>
        <ContentWrapper>
          <Title>
            <T>Welcome to Sweet Factory Store!</T>
          </Title>
          <ScrollableSlides scrollContainer={scrollContainer} onChildChange={onChildChange}>
            {slides.map((slide, index) => (
              <Slide
                key={slide.id}
                {...slide}
                current={index}
                total={slides.length}
                backgroundColor={currentSlide.backgroundColor}
              />
            ))}
          </ScrollableSlides>
          <ButtonWrapper>
            {currentChildIndex === slides.length - 1 ? (
              <Button className="primary" onClick={navigateToLogin}>
                <T>Let’s begin!</T>
              </Button>
            ) : (
              <Button className="primary" onClick={scrollToNext} type="button">
                <T>Next</T>
              </Button>
            )}
          </ButtonWrapper>
        </ContentWrapper>
      </PageWrapper>
    </>
  );
}
